export default __webpack_public_path__ + "static/media/icon_success_register.644e2f9b.svg";